import React from 'react';
import { Outlet } from 'react-router-dom';

const BuildingManagementRoute = () => {
  return <Outlet />;
};

export default BuildingManagementRoute;
